import React from 'react';

export const Terms = () => {
  return (
    <div className="min-h-screen pt-20 pb-12">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms and Conditions</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-sm text-gray-500 mb-8">Last updated: November 11, 2025</p>
          
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              By accessing and using i5World services, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Use of Services</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              i5World provides high-speed internet, OTT IPTV, and roaming WiFi services. You agree to use these services only for lawful purposes and in accordance with these Terms and Conditions.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Service Plans and Billing</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              All service plans are subject to availability and may be modified or discontinued at any time. Billing will be conducted according to the plan you select.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              You agree to pay all fees and charges incurred in connection with your use of the services. Failure to pay may result in suspension or termination of services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Installation and Equipment</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              i5World will provide free professional installation for all plans. Any equipment provided remains the property of i5World and must be returned upon termination of service.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              You are responsible for the care and maintenance of equipment provided. Damage or loss may result in additional charges.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Service Availability</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              While we strive to provide 99.9% uptime, i5World does not guarantee uninterrupted service. We are not liable for any service interruptions caused by factors beyond our control.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Roaming WiFi Service</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Roaming WiFi service allows you to access public WiFi hotspots at i5World locations using your home plan credentials through our captive portal. This service is available wherever i5World broadband is installed across cities and states.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              You agree to use this service responsibly and not to share your login credentials with unauthorized users.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Prohibited Activities</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              You agree not to use our services for any illegal activities, including but not limited to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Distributing copyrighted material without authorization</li>
              <li>Hacking or attempting to gain unauthorized access to systems</li>
              <li>Sending spam or malicious software</li>
              <li>Engaging in fraudulent activities</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Data Usage and Fair Use Policy</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              All our plans come with truly unlimited data. However, we reserve the right to manage network traffic to ensure optimal performance for all users.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Termination</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Either party may terminate this agreement with 30 days written notice. i5World reserves the right to immediately terminate service for violations of these terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              i5World shall not be liable for any indirect, incidental, special, consequential or punitive damages resulting from your use or inability to use the service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              i5World reserves the right to modify these terms at any time. Continued use of the service after changes constitutes acceptance of the modified terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Governing Law</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              These terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in Ahmedabad, Gujarat.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Contact Information</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              For any questions regarding these terms, please contact us at:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700 mb-2"><strong>i5World</strong></p>
              <p className="text-gray-700 mb-2">907 Pinnacle Business Park</p>
              <p className="text-gray-700 mb-2">Corporate Road, Prahlad Nagar</p>
              <p className="text-gray-700 mb-2">Ahmedabad, Gujarat - 380015</p>
              <p className="text-gray-700">Email: info@i5world.com</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
